cockpitApp.directive('hintBarError', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/sections/hint-bar-error'
  };
});
